import React from "react";
import { Container, makeStyles, useTheme } from "@material-ui/core";
import publicMainStyle from "assets/jss/components/publicMainStyles";
import secureLoadingImg from "assets/img/connection-animation-2.gif";

const useStyles = makeStyles(publicMainStyle);

const PublicSecureLoading = () => {
  const classes = useStyles();
  const { logo } = useTheme();

  return (
    <Container className={classes.root}>
      <Container className={classes.loadingArea} maxWidth="xs">
        <div className={classes.paper}>
          <div className={classes.logoWrapper}>
            <img src={logo} alt="logo" className={classes.wrappedImg} />
          </div>
          <div className={classes.gifWrapper}>
            <img src={secureLoadingImg} alt="..." className={classes.wrappedImg} />
          </div>
        </div>
      </Container>
    </Container>
  );
};

export default PublicSecureLoading;
